var openInfoWindow = null;

var initializeBlockMap = function(block){
	
	if(typeof mapData === 'undefined') {
		return false;
	}
	
	var mapElement = jQuery("#map");
	var lat = parseFloat(mapData.lat);
	var lng = parseFloat(mapData.lng);
	var zoom = parseFloat(mapData.zoom);
	var markerData = JSON.parse(mapData.markers);
	var markers = [];
		
	var map = new google.maps.Map(mapElement[0], {
		center				: {lat: lat, lng: lng},
		zoom				: zoom,
		mapTypeControl		: false,
		scaleControl		: false,
		streetViewControl	: false,
		rotateControl		: false,
		fullscreenControl	: false,
		//styles  			: mapStyles
	});
	
	for(var i=0; i<markerData.length; i++) {
		createMarker(markerData[i], map, markers);
	}
	
	centerMap(markers, map);
	
	jQuery("#map").on("click", ".gm-style-iw", function(){
		jQuery(".extra-content", this).addClass("show");
	});
	
}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-map').each(function(){
		initializeBlockMap(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=map', initializeBlockMap);


function createMarker(markerData, map, markers) {
	
	var markerWidth = 29;
	var markerHeight = 57;
	//var markerDefault = "/wp-content/themes/plumbweb-child/_assets/img/marker.svg";
	//var markerHover = "/wp-content/themes/plumbweb-child/_assets/img/marker-hover.svg";
	
	var marker = new google.maps.Marker({
		map			: map,
		position	: {lat: markerData.lat, lng: markerData.lng},
		///icon 		: { 
		//	url			: markerDefault, 
		//	size		: new google.maps.Size(markerWidth, markerHeight), 
		//	scaledSize	: new google.maps.Size(markerWidth, markerHeight)
		//}
	});
	
	var infowindow = new google.maps.InfoWindow({
		content: markerData.html,
		position: {lat: markerData.lat, lng: markerData.lng}
	});
	
	infowindow.open(map);
	
	openInfoWindow = infowindow;
	
	markers.push(marker);
	
}

function centerMap(markers, map){
	
	if(markers.length){
	
		var bounds = new google.maps.LatLngBounds();
		
		for(var i=0; i<markers.length; i++){
			
			bounds.extend({
				lat: markers[i].position.lat(),
				lng: markers[i].position.lng()
			});
			
		}
	
		if(markers.length == 1){
			map.setCenter(bounds.getCenter());
	
		} else{
			map.fitBounds(bounds);
		}
		
		setTimeout(function(){
			map.setZoom(map.getZoom() - 1);
		}, 10);
	
	}
	
}
